import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import serviceMassemottak from "@/assets/service-massemottak.webp";
import serviceSalg from "@/assets/service-salg.webp";
import kompetansesenterService from "@/assets/envir-lab-detaljbilde-640.webp";
import { useLanguage, translations } from "@/i18n/LanguageContext";

const images = [serviceMassemottak, serviceSalg, kompetansesenterService];
const serviceLinks = ["/mottak", "/gjenvunne-masser", "/kompetansesenter"];

const ServicesSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });
  const { t } = useLanguage();

  return (
    <section id="tjenester" ref={ref} className="section-padding py-24 md:py-36 bg-card">
      <div className="max-w-7xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={isInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.7 }} className="mb-16">
          <span className="text-sm font-body font-500 tracking-widest uppercase text-primary mb-4 block">{t(translations.services.label)}</span>
          <h2 className="heading-lg text-foreground">{t(translations.services.title)}</h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-4">
          {translations.services.items.map((service, i) => (
            <motion.a
              key={i}
              href={serviceLinks[i]}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, delay: 0.2 + i * 0.15 }}
              className="group relative aspect-[3/4] overflow-hidden rounded cursor-pointer"
            >
              <img src={images[i]} alt={t(service.title)} loading="lazy" decoding="async" width={640} height={800} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-envir-charcoal/90 via-envir-charcoal/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h3 className="heading-md text-primary-foreground mb-2">{t(service.title)}</h3>
                    <p className="body-md text-primary-foreground/60 group-hover:text-primary-foreground/80 transition-colors">{t(service.description)}</p>
                  </div>
                  <ArrowUpRight className="w-6 h-6 text-primary-foreground/50 group-hover:text-primary transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 flex-shrink-0 mt-1" />
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
